<template>
	<div>
		<vs-card>
			<div slot="header">
				<h3>Evento: {{ this.motivo }}</h3>
			</div>
			<div>
				<vs-row>
					<vs-col v-for="(pergunta, index) in perguntas" :key="pergunta.id">
						<label
							v-if="
								(pergunta.isAberta || pergunta.isSN) &&
								(pergunta.idPerguntaDependente === 0 ||
									respostas[respostas[index].posicaoRespostaDependente].resposta)
							"
						>
							{{ pergunta.pergunta }}
						</label>
						<vs-input
							v-if="
								pergunta.isAberta &&
								(pergunta.idPerguntaDependente === 0 ||
									respostas[respostas[index].posicaoRespostaDependente].resposta)
							"
							:name="pergunta.pergunta"
							class="w-full mb-3"
							v-model="respostas[index].resposta"
							v-validate="{ required: true }"
							:state="validateState(pergunta.pergunta)"
							:class="validateClass(pergunta.pergunta)"
						/>
						<vs-switch
							class="mb-3"
							v-model="respostas[index].resposta"
							v-else-if="
								pergunta.isSN &&
								(pergunta.idPerguntaDependente === 0 ||
									respostas[respostas[index].posicaoRespostaDependente].resposta)
							"
							style="width: 60px"
						>
							<span slot="on">Sim</span>
							<span slot="off">Não</span>
						</vs-switch>
						<div
							class="mt-4 mb-4"
							v-if="
								!pergunta.isNota &&
								!pergunta.isAberta &&
								!pergunta.isSN &&
								!pergunta.isMultiplaEscolha
							"
						>
							<vs-alert title="Orientações" active="true" color="primary">
								<span>{{ pergunta.pergunta }}</span>
							</vs-alert>
						</div>
					</vs-col>
				</vs-row>
				<vs-row>
					<vs-col class="w-full text-right">
						<vs-button
							color="dark"
							@click="validarCampos()"
							type="gradient"
							class="mt-2 mb-2"
						>
							Salvar Respostas
						</vs-button>
					</vs-col>
				</vs-row>
				<vs-alert
					v-if="$validator.errors.all().length > 0"
					color="danger"
					title="Atenção"
					active="true"
					class="my-3"
					style="height: auto !important"
				>
					<ul>
						<li class="mb-2" v-for="error in $validator.errors.all()" :key="error.id">
							{{ error }}
						</li>
					</ul>
				</vs-alert>
			</div>
		</vs-card>
	</div>
</template>
<script>
import locale from "../../../locale";
import service from "../../../services/index";
export default {
	props: ["idEmpresa", "idChecklist", "motivo", "edicao"],
	data() {
		return {
			perguntas: [],
			respostas: [],
			respostasPreechidas: [],
		};
	},
	created() {
		this.$validator.localize("ptBr", locale);
		this.buscarPerguntas();
	},
	methods: {
		buscarPerguntas() {
			this.$vs.loading();
			service
				.getAll("Checklist", {}, `buscarPerguntas/${this.motivo}`)
				.then((res) => {
					this.perguntas = res.data;
					this.montarRespostas(res.data);
					this.edicao && this.buscarRespostasPrenchidas();
					this.$vs.loading.close();
				})
				.catch((e) => {
					console.log(e);
					this.dadosResult = null;
					this.$vs.loading.close();
					this.$vs.notify({
						position: "top-center",
						title: "Atenção",
						text: e,
						color: "danger",
					});
				});
		},
		montarRespostas(perguntas) {
			perguntas.forEach((pergunta) => {
				let posicaoRespostaDependente = null;
				if (pergunta.idPerguntaDependente !== 0) {
					posicaoRespostaDependente = this.perguntas.findIndex(
						(per) => per.idPergunta === pergunta.idPerguntaDependente
					);
				}
				this.respostas.push({
					idEmpresa: this.idEmpresa,
					idPergunta: pergunta.idPergunta,
					idChecklist: this.idChecklist,
					posicaoRespostaDependente,
					motivo: this.motivo,
					resposta:
						pergunta.isAberta ||
						pergunta.isNota ||
						pergunta.MultiplaEscolha ||
						!pergunta.isSN
							? null
							: false,
				});
			});
		},
		buscarRespostasPrenchidas() {
			this.$vs.loading();
			service
				.post("Checklist", "buscarRespostasChecklist", { id_checklist: this.idChecklist, motivo: this.motivo })
				.then((res) => {
					this.montarRespostasPrenchidas(res.data);
					this.$vs.loading.close();
				})
				.catch((e) => {
					this.$vs.notify({
						position: "top-center",
						title: "Atenção",
						text: e,
						color: "danger",
					});
					this.$vs.loading.close();
				});
		},
		montarRespostasPrenchidas(data) {
			data.forEach((resposta) => {
				const indexPergunta = this.perguntas.findIndex(
					(pergunta) => pergunta.idPergunta === resposta.idPergunta
				);

				if (indexPergunta !== -1) {
					this.respostas[indexPergunta].idChecklist = resposta.idChecklist;
					this.respostas[indexPergunta].resposta = resposta.resposta;
					this.respostas[indexPergunta].idEmpresa = resposta.Id_Pergunta.idEmpresa;
					this.respostas[indexPergunta].idResposta = resposta.idResposta;
				}
			});
			this.converterSimNaoParaBoleano();
		},
		async validarCampos() {
			await this.$validator.validateAll();
			if (this.$validator.errors.all().length === 0) {
				this.corrigerRespostasDependentesAninhadas();
				this.removerRespostasDependentesNegativas();
				this.removerRespostasNulas();
				this.converterSimNao();
				this.edicao ? this.atualizarRespostas() : this.salvarRespostas();
			}
		},
		validateState(ref) {
			if (
				this.veeFields[ref] &&
				(this.veeFields[ref].dirty || this.veeFields[ref].validated)
			) {
				return !this.veeErrors.has(ref);
			}
			return null;
		},
		validateClass(ref) {
			if (
				this.veeFields[ref] &&
				(this.veeFields[ref].dirty || this.veeFields[ref].validated)
			) {
				return this.veeErrors.has(ref) ? "has-error" : "";
			}
			return null;
		},
		converterSimNao() {
			this.respostasPreechidas = this.respostasPreechidas.map((resposta) =>
				typeof resposta.resposta === "boolean"
					? { ...resposta, resposta: resposta.resposta ? "sim" : "não" }
					: resposta
			);
		},
		converterSimNaoParaBoleano() {
			this.respostas = this.respostas.map((resposta) =>
				resposta.resposta === "sim" || resposta.resposta === "não"
					? { ...resposta, resposta: resposta.resposta === "sim" ? true : false }
					: resposta
			);
		},
		corrigerRespostasDependentesAninhadas() {
			this.respostas.forEach((resposta, index) => {
				if (
					resposta.posicaoRespostaDependente !== null &&
					this.respostas[resposta.posicaoRespostaDependente].resposta !==
						this.perguntas[index].respostaDependente &&
					this.respostas[index].resposta === true
				) {
					this.respostas[index].resposta = !this.respostas[index].resposta;
				}
			});
		},
		removerRespostasDependentesNegativas() {
			this.respostasPreechidas = this.respostas.filter(
				(resposta, index) =>
					resposta.posicaoRespostaDependente === null ||
					this.respostas[resposta.posicaoRespostaDependente].resposta ===
						this.perguntas[index].respostaDependente
			);
		},
		removerRespostasNulas() {
			this.respostasPreechidas = this.respostasPreechidas
				.filter((resposta) => resposta.resposta !== null)
				.map((resposta) => {
					delete resposta.posicaoRespostaDependente;
					return resposta;
				});
		},
		salvarRespostas() {
			this.$vs.loading();
			service
				.post("Checklist", "registrarRespostas", this.respostasPreechidas)
				.then((res) => {
					this.$vs.notify({
						position: "top-center",
						title: "Atenção",
						text: "Respostas salvas com sucesso",
						color: "success",
					});
					console.log(res.data);
					this.$vs.loading.close();
					this.voltarParaChecklist();
				})
				.catch((e) => {
					this.$vs.notify({
						position: "top-center",
						title: "Atenção",
						text: e,
						color: "danger",
					});
					this.$vs.loading.close();
				});
		},
		atualizarRespostas() {
			this.$vs.loading();
			service
				.put("Checklist", "atualizarRespostas", this.respostasPreechidas)
				.then((res) => {
					this.$vs.notify({
						position: "top-center",
						title: "Atenção",
						text: "Respostas salvas com sucesso",
						color: "success",
					});
					console.log(res.data);
					this.$vs.loading.close();
					this.voltarParaChecklist();
				})
				.catch((e) => {
					this.$vs.notify({
						position: "top-center",
						title: "Atenção",
						text: e,
						color: "danger",
					});
					this.$vs.loading.close();
				});
		},
		voltarParaChecklist() {
			this.$router.go(-1);
		},
	},
	computed: {
		
	}
};
</script>

<style scoped>
label {
	font-size: 1.08em;
	color: rgb(99, 99, 99);
}
.Orientacao {
	color: brown;
	font-size: large;
}
</style>
